import React, {useState} from "react";
import {useTranslation} from "react-i18next";
const ShowFile = ({pdfUrl, setShowFile}) => {
    const {t} = useTranslation();
    const [fullscreen, setFullScreen] = useState(false)
    return (
        <div className="modal show d-block file" tabIndex="-1" role="dialog" style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1001}}>
            <div className={`modal-dialog ${fullscreen ? 'modal-fullscreen' : 'modal-xl'}`} role="document">
                <div className="modal-content">
                    <div className="modal-header justify-content-between">
                        <h5 className="modal-title">{t('pdf_file')}</h5>
                        <div className="d-flex align-items-center">
                            {
                                fullscreen ?
                                    <i style={{cursor: 'pointer'}} className="bi bi-fullscreen-exit"
                                       title={t('full_screen')}
                                       onClick={() => {
                                           setFullScreen(false)
                                       }}></i>
                                    :
                                    <i style={{cursor: 'pointer'}} className="bi bi-arrows-fullscreen"
                                       title={t('full_screen')}
                                       onClick={() => {
                                           setFullScreen(true)
                                       }}></i>
                            }
                            <button type="button" className="btn-close" title={t('close')} onClick={() => {
                                setShowFile(false);
                                URL.revokeObjectURL(pdfUrl);
                            }}></button>
                        </div>
                    </div>
                    <div className="modal-body" style={{height: '80vh'}}>
                        <iframe src={pdfUrl} width="100%" height="100%" title={t('translation:pdf_file')}
                                frameBorder="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowFile